export default "__VITE_ASSET__BIlHD1Xf__"